export var PriceTypes;
(function (PriceTypes) {
    PriceTypes["NET_PRICE"] = "NetPrice";
    PriceTypes["FINAL_PRICE"] = "FinalPrice";
})(PriceTypes || (PriceTypes = {}));
//# sourceMappingURL=PriceTypes.js.map